import styled from 'styled-components';

export const StyledLink = styled.a`
  cursor: pointer;
  color: ${({ theme }): string => theme.admanColors!.blue.dark.bg1[0]};
  text-decoration: none;
  letter-spacing: -0.005em;
`;
